export class Incident {
    public title: string;
    public url: string;
}

export class IncidentInfo {
    public incidents: Incident[];
}

export class Announcement {
    public title: string;
    public subtitle: string;
    public announcementDate: Date;
    public summaryText: string;

    public iconUrl: string;
    public moreInfoUrl: string;
    public downloadUrl: string;
    public requirementsUrl: string;

    public fixedInTopics: FixedIssueTopicInfo[];
}

export class AnnouncementInfo {
    public release: Announcement | null;
    public preview: Announcement | null;
}

export enum AlertType {
    Outage = 0,
    Degraded = 1,
    Advisory = 2,
    Mitigated = 3,
}

export class Alert {
    public alertId: number;
    public title: string;
    public alertType: AlertType;
    public description: string | null;
    public url: string | null;
    public startDate: Date | null;
    public endDate: Date | null;
    public isActive: boolean;
    public createdDate: Date;
    public lastUpdatedDate: Date;
}

export class FixedIssueTopicInfo {
    public issueCount: number;
    public url: string;
    public shortName: string; // example: '15.5 Preview 1'
}
